import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixHoverCard from "@radix-ui/react-hover-card";
const hoverCard = tailwindVariants({
    base: "z-portal w-full overflow-y-auto rounded bg-white p-2 shadow-popover outline-none radix-side-bottom:animate-slide-up radix-side-top:animate-slide-down"
});
export const HoverCard = (param)=>{
    let { defaultOpen, children, className, closeDelay, open, onOpenChange, openDelay, sideOffset = 8, trigger, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs(RadixHoverCard.Root, {
        defaultOpen: defaultOpen,
        closeDelay: closeDelay,
        onOpenChange: onOpenChange,
        open: open,
        openDelay: openDelay,
        children: [
            /*#__PURE__*/ _jsx(RadixHoverCard.Trigger, {
                asChild: true,
                "data-testid": "HOVER_CARD_TRIGGER",
                children: trigger
            }),
            /*#__PURE__*/ _jsx(RadixHoverCard.Portal, {
                children: /*#__PURE__*/ _jsx(RadixHoverCard.Content, {
                    className: hoverCard({
                        className
                    }),
                    "data-testid": "HOVER_CARD",
                    ...restOfProps,
                    sideOffset: sideOffset,
                    children: children
                })
            })
        ]
    });
};
